//  here we define mapping from all different imported country codes
//  to our database indexes

export const countrysMapping = [
  //IPHandlers
  { oldValue: "UGEBB", newValue: "222" },
  { oldValue: "ECUIO", newValue: "62" },
  { oldValue: "KENBO", newValue: "110" },
  { oldValue: "COBOG", newValue: "47" },
  { oldValue: "NLAMS", newValue: "150" },
  { oldValue: "ILTLV", newValue: "104" },
  { oldValue: "TWTYN", newValue: "208" },
  { oldValue: "TWTPE", newValue: "208" },
  { oldValue: "TRAYT", newValue: "218" },
  { oldValue: "RUMOW", newValue: "177" },
  { oldValue: "-", newValue: "150" },
  { oldValue: "", newValue: "150" },
  { oldValue: "EBB", newValue: "222" },
  { oldValue: "UIO", newValue: "62" },
  { oldValue: "NBO", newValue: "110" },
  { oldValue: "BOG", newValue: "47" },
  { oldValue: "AMS", newValue: "150" },
  { oldValue: "TLV", newValue: "104" },
  { oldValue: "TYN", newValue: "208" },
  { oldValue: "TPE", newValue: "208" },
  { oldValue: "AYT", newValue: "218" },
  { oldValue: "MOW", newValue: "177" },

  // KN
  { oldValue: "Quito, Ecuador", newValue: "62" },
  { oldValue: "Tel Aviv, Israel", newValue: "104" },
  { oldValue: "Bogota, Columbia", newValue: "47  " },
  { oldValue: "Nairobi, Kenya", newValue: "110" },
  { oldValue: "Amsterdam,", newValue: "150" },
];



// WEBPACK FOOTER //
// ./src/schemas/country_mapping.js